// @ts-nocheck

import Konva from 'konva';

const getTextWidth = (text, bounds) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { width, ...boundsWithoutWidth } = bounds; // remove width from attributes because we don't want to limit the computed width
  return Math.ceil(new Konva.Text({ ...boundsWithoutWidth, text }).getWidth());
};

/*
 * Fragment text with react konva
 * param text - String
 * param bounds - Konva Text attributes which influence text size, should have width as maxWidth
 * return Array of Object with text and width for each lines
 */
export const fragmentText = (text, bounds) => {
  const words = text.split(' ');
  const lines = [];
  let line = '';
  const { width: maxWidth } = bounds;
  const totalWidth = getTextWidth(text + ' ', bounds);
  if (totalWidth < maxWidth) {
    return [{ text: text, width: totalWidth }];
  }
  while (words.length > 0) {
    // add line or add word to line
    if (getTextWidth(line + words[0], bounds) < maxWidth) {
      // we can add word
      line += words.shift() + ' ';
    } else {
      if (line === '') {
        line += words.shift() + ' ';
      }
      // we add line and start a new one
      lines.push({ text: line, width: getTextWidth(line, bounds) });
      line = '';
    }
    if (words.length === 0) {
      lines.push({ text: line, width: getTextWidth(line, bounds) });
    }
  }
  return lines;
};

/*
  Check if there is enough space to place outcome result on the same line as bet title
  Return label position, width and a boolean to say if we manage to place label on the same line as bet title
*/
export default (betTitle, boundsBetTitle, label, boundsLabel) => {
  const linesBetTitle = fragmentText(betTitle, boundsBetTitle);
  const lastBetTitleLineWidth = linesBetTitle[linesBetTitle.length - 1].width;

  const remainingSpace = boundsBetTitle.width - (lastBetTitleLineWidth - (boundsLabel.paddingLeft || 0) * 2);
  let labelWidth = getTextWidth(label, boundsLabel);
  const isUsingRemainingSpace = labelWidth < remainingSpace;

  let xLabel = 0;
  let yLabel = 0;
  if (isUsingRemainingSpace) {
    xLabel = lastBetTitleLineWidth;
    yLabel = (linesBetTitle.length - 1) * boundsBetTitle.fontSize * boundsBetTitle.lineHeight;
  } else {
    const linesLabel = fragmentText(label, boundsLabel);
    labelWidth = linesLabel.reduce((acc, cur) => Math.max(cur.width, acc), 0);
    yLabel = linesBetTitle.length * boundsBetTitle.fontSize * boundsBetTitle.lineHeight;
  }

  return { xLabel, yLabel, labelWidth, isUsingRemainingSpace };
};
